// extracted by mini-css-extract-plugin
export default {"liveHead":"live_liveHead__oro6D","liveList":"live_liveList__-71x2","liveNo":"live_liveNo__eVwJl"};